import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { de } from './de';
import { ar } from './ar';
import { zh } from './zh';
import type { SupportedLanguage, TranslationKeys } from '../index';

export const translations: Record<SupportedLanguage, TranslationKeys> = {
  en,
  es,
  fr,
  de,
  it: en, // Fallback to English for now
  pt: en, // Fallback to English for now
  ru: en, // Fallback to English for now
  ja: en, // Fallback to English for now
  ar,
  he: ar, // Use Arabic as fallback for Hebrew (similar RTL structure)
  zh
};

export * from './en';
export * from './es';
export * from './fr';
export * from './de';
export * from './ar';
export * from './zh';